import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const dynamicFixRecord = dict => dict.dynamicFixRecord;
const fixFRPRecord = dictDynamicFixFRPRecord => () => ({dynamicFixFRP: dictMonadFRP => dictDynamicFixFRPRecord.dynamicFixRecord(dictMonadFRP)(Type$dProxy.Proxy)});
const dynamicFixFRPRecordNil = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    dynamicFixRecord: dictMonadFRP => {
      const map = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
      return v => v1 => f => map(Data$dTuple.snd)(f(to({})));
    }
  };
};
const dynamicFixFRPDynamic = {
  dynamicFixFRP: dictMonadFRP => {
    const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
    const Bind1 = Monad0.Bind1();
    const $$new = Specular$dRef.new(dictMonadFRP.MonadEffect0());
    const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
    const pure = Monad0.Applicative0().pure;
    return initial => callback => Bind1.bind($$new(initial))(ref => Bind1.bind(callback(ref._1))(v => {
      const $0 = v._2;
      return Bind1.bind(subscribeDyn_(x => ref._2(_old => x))(v._1))(() => pure($0));
    }));
  }
};
const dynamicFixFRP = dict => dict.dynamicFixFRP;
const dynamicFixFRPRecord = dictIsSymbol => () => () => () => () => dictDynamicFixFRP => dictDynamicFixFRPRecord => (
  {
    dynamicFixRecord: dictMonadFRP => {
      const dynamicFixFRP2 = dictDynamicFixFRP.dynamicFixFRP(dictMonadFRP);
      const dynamicFixRecord2 = dictDynamicFixFRPRecord.dynamicFixRecord(dictMonadFRP);
      const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
      const bind = Monad0.Bind1().bind;
      const pure = Monad0.Applicative0().pure;
      return v => initial => f => dynamicFixFRP2(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(initial))(v1 => dynamicFixRecord2(Type$dProxy.Proxy)(Record$dUnsafe.unsafeDelete(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(initial))(v2 => bind(f(Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v1)(v2)))(v3 => pure(Data$dTuple.$Tuple(
        Record$dUnsafe.unsafeDelete(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v3._1),
        Data$dTuple.$Tuple(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v3._1), v3._2)
      )))));
    }
  }
);
export {dynamicFixFRP, dynamicFixFRPDynamic, dynamicFixFRPRecord, dynamicFixFRPRecordNil, dynamicFixRecord, fixFRPRecord};
